import React, { Component } from 'react'
import TalksFramework from '../../components/TalksFramework'
import EndSplash from '../../components/EndSplash'
import get from 'lodash/get'
import { EndProps } from './types'

class End extends Component<EndProps> {

  componentDidMount () {

    this.props.tearDownGig()
    this.checkStatus()

  }

  componentDidUpdate () {

    this.checkStatus()

  }

  checkStatus = () => {

    const roomname = get(this.props.match, 'params.roomname', '')

    if (!this.props.isEndRequested && !this.props.hasGigEnded) {

      return this.props.history.replace(`/${roomname}`)

    }

  }

  render () {

    return <TalksFramework
      content={
        <EndSplash
          hasGigEnded={this.props.hasGigEnded}
          isEndRequested={this.props.isEndRequested}
          status={this.props.status}
        />
      }
    />

  }

}

export default End
